let translationsALIST = {
	'underground4': 'underground4',
	'underground3': 'underground3',
	'underground2': 'underground2',
	'underground1': 'underground1',
	'basement': 'basement',
	'suteren': 'suteren',
	'halfSuteren': 'halfSuteren',
	'downstairs': 'downstairs',
	'highDownstairs': 'highDownstairs',
	'halfUpstairs': 'halfUpstairs',
	'20+': '20+',
	'10+': '10+',
	'order': 'Order',
	'dateDesc': 'Newest on top',
	'dateAsc': 'Oldest on top',
	'priceDesc': 'The most expensive on top',
	'priceAsc': 'Cheapest on top',
	'orderPlaceholder': 'Choose order',
	'hitsText': 'hit(s)'
};
// emeletek
for (let i = 1; i <= 10; ++i) {
	translationsALIST[i] = 'floor ' + i;
}

export default translationsALIST;
